export default (api) => ({
  getAll: transactionId => api.get(`/transfer-orders/transaction/${transactionId}`),
  resend: transferOrderId => api.post(`/transfer-orders/${transferOrderId}`),
  markDeclined: transferOrderId => api.post(`/transfer-orders/${transferOrderId}/mark-declined`)
})
